import { 
  includeFields,
  // RIMS_LOCAL_STG_CONSTANTS, RTQ_EVENTS, 
  MENU_MODULE_NAME_MAP 
} from "../constants";
// import eventBus from "./eventBus";
import { isEqual } from "lodash-es";
import { t } from "i18next";
import SnackbarUtils from "../components/NotistackPlus";

export function translateStatus(status: any) {
  if (status === '') {
    return ''
  } else {
    switch (Number(status)) {
      case 0:
        return 'In-Draft';
      case 1:
        return 'Active';
      case 2:
        return 'Inactive'
      case 3:
        return 'Archived'
      default:
        return 'In-Draft'
    }
  }
}

export const toArray = (value: any) => {
  return Array.isArray(value) ? value : [value];
}

export const hasMenuAuth = (
  authList: API.AuthItem[] | undefined,
  code: string,
) => (authList ?? []).some((item) => item.name === code);

export function mappingAdminType(type: string) {
  switch (type) {
    case 'user':
      return 0;
    case 'role':
      return 1;
    case 'group':
      return 2;
    case 'acl':
      return 3;
    default:
      return 0
  }
}

export function uniqueArray(arr: any[], propName?: string) {
  const res = new Map();
  if (propName) {
    return arr.filter((a) => !res.has(a[propName]) && res.set(a[propName], 1));
  } else {
    return arr.filter((a) => !res.has(a) && res.set(a, 1));
  }
}

export function titleCase(str: string) {
  let newStr = str.split(" ");
  for (let i = 0; i < newStr.length; i++) {
    newStr[i] = newStr[i].slice(0, 1).toUpperCase() + newStr[i].slice(1).toLowerCase();
  }
  return newStr.join(" ");
}

export function firstWordCase(parameter: string) {
  const curParam = parameter ?? '';
  return curParam.slice(0, 1).toUpperCase() + curParam.slice(1).toLowerCase();
}

// export function handleExportByType(api: string, enqueueSnackbar: any, data?: any) {
//   let params = {
//     api: api,
//     data: data ? data : {},
//     enqueueSnackbar: enqueueSnackbar
//   }
//   eventBus.emit(RTQ_EVENTS.COMMON.EXPORT_FILE_START, params)
// }

export function logoutFunction() {
  localStorage.clear();
}

const isObject = (target: any) => {
  return (typeof target === 'object' || typeof target === 'function')
    && (target !== null);
};

export function deepClone(target: any, map = new WeakMap()) {
  if (map.get(target)) {
    return target;
  }
  if (isObject(target)) {
    map.set(target, true);
    const cloneTarget: any = Array.isArray(target) ? [] : {};
    for (let prop in target) {
      if (target.hasOwnProperty(prop)) {
        cloneTarget[prop] = deepClone(target[prop], map);
      }
    }
    return cloneTarget;
  } else {
    return target;
  }
};

export function getObjectDataType(data: any) {
  const temp = Object.prototype.toString.call(data);
  const type = temp?.match(/\b\w+\b/g) || [];
  return (type.length < 2) ? 'Undefined' : type[1];
}

export function isObjectChanged(source: any, comparison: any): any {
  const iterable = (data: any) => ['Object', 'Array'].includes(getObjectDataType(data));
  if (getObjectDataType(source) !== getObjectDataType(comparison)) {
    return true;
  }
  const sourceKeys = Object.keys(source);
  const comparisonKeys = Object.keys({ ...source, ...comparison });
  if (sourceKeys.length !== comparisonKeys.length) {
    return true;
  }
  return comparisonKeys.some((key: any) => {
    if (iterable(source[key])) {
      return isObjectChanged(source[key], comparison[key]);
    } else {
      return source[key] !== comparison[key];
    }
  });
}

export const uploadFileSize = (input: any) => {
  let Sys = {
    ie: false,
    firefox: false,
    Chrome: false
  };
  let filesize = 0;
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf("MSIE") > 0 || userAgent.indexOf("rv:11.0") > 0) {
    Sys.ie = true;
  }
  if (userAgent.indexOf("Firefox") > 0) {
    Sys.firefox = true;
  }
  if (userAgent.indexOf("Chrome") > 0) {
    Sys.Chrome = true;
  }

  if (Sys.firefox || Sys.Chrome) {
    filesize = input.files[0].size;
  } else if (Sys.ie) {
    //@ts-ignore
    const fileobject = new ActiveXObject("Scripting.FileSystemObject");
    const file = fileobject.GetFile(input.value);
    filesize = file.Size;
  }
  return filesize / (1024 * 1024)
}

export function dateSortComparator(a: any, b: any): any {
  return Date.parse(a ?? 0) - Date.parse(b ?? 0)
}

export function operatorName(name: any) {
  switch (name) {
    case "contains":
      return 'Contains'
    case "equals":
      return 'Equals'
    case "startsWith":
      return 'Starts With'
    case "endsWith":
      return 'Ends With'
    case "isEmpty":
      return 'is Empty'
    case "isNotEmpty":
      return 'is Not Empty'
    default:
      return '';
  }
}

export function handleAPICommonError(err: any) {
  if (err?.response?.status === 401 || err?.response?.data?.message === "unauthorized") {
    return;
  }
}

export const handlePromiseError = (error: any) => {
  const curStatus = error?.response?.status;
  const curMsg =
    error?.response?.data?.message || t("common.tip.commonErrorMessage");
  if (curStatus === 401 || curMsg === "unauthorized") {
    return;
  }
  if (curStatus !== 400 && curStatus !== 500) {
    SnackbarUtils.error(curMsg);
  }
};

export const getAllIds = (tree: any, result: any) => {
  if (!Array.isArray(tree)) return [];
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i];
    result.push(node.id);
    if (Array.isArray(node.children)) {
      getAllIds(node.children, result);
    }
  }
  return result;
}

export const canParseToJson = (str: any) => {
  if (typeof str == 'string') {
    try {
      var obj = JSON.parse(str);
      if (typeof obj == 'object' && obj) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
}

export function dependencyTypeName(type: any) {
  switch (type) {
    case 0:
      return 'User'
    case 1:
      return 'User Group'
    case 2:
      return 'Role'
    case 3:
      return 'ACL'
    case 4:
      return 'RTQ'
    case 5:
      return 'Question'
    case 6:
      return 'Workflow'
    default:
      return '';
  }
}

export function changeProductPageTitle(value: string) {
  switch (value) {
    case 'Product Information':
      return 'Product Information';
    case 'Active Ingredient/Substance':
      return 'Active Ingredient/Substance'
    case 'Trade Name':
      return 'Trade Name'
    default:
      return 'Trade Name'
  }
}

export function changeRTQPageTitle(value: number) {
  switch (value) {
    case 0:
      return 'basicInformation';
    case 1:
      return 'questionResponseDetails'
    case 4:
      return 'products'
    case 5:
      return 'submissions'
    case 2:
      return 'categories'
    case 3:
      return 'documents'
    case 6:
      return 'workflow'
    default:
      return 'basicInformation'
  }
}

// Convert the name to index
export const metaRtqTabIndexObj: Record<string, number> = {
  "Basic Information": 0,
  'Question & Response Details': 1,
  'Categories': 2,
  'Documents': 3,
  "Linked Products": 4,
  "Linked Submissions": 5
};

export function getModuleName(path: string) {
  // @ts-ignore
  for (let [module, paths] of MENU_MODULE_NAME_MAP.entries()) {
    if (path && paths.includes(path)) {
      return module;
    }
  }
  return null; // If no match is found
};

export function getURLDomain() {
  const domain = process.env.REACT_APP_STG_DOMAIN || '';
  const splitByDomain = window.location.hostname.split(domain);
  const splitByDot = splitByDomain[0]?.split('.');
  const domainName = splitByDot[1] ? `${splitByDot[1]}.${domain}` : `${domain}`

  return domainName
}

export const sortFn = (a: any, b: any) => {
  return a.order - b.order
}

export const transferToAlias = (name: string) => {
  const array = name.match(/\b[A-Za-z0-9](?:[a-z0-9]*|[A-Z0-9]*(?=[a-z]))\b/g);

  if (!array) return "";
  const kebabCase = array?.map((word) => word.toLowerCase()).join("-");

  return kebabCase;
};

interface singleIdentifiersMeta {
  module: string;
  section: string;
  menu: string;
}

const transElementToStr = (element: any) => Array.isArray(element) ? '' : element;

export const handleSelectedIdentifiersMeta = (
  originalMeta: Record<string, any>,
  originalIdentifierMap: Record<string, any>
) => {
  // const pickKeys = Object.keys(originalMeta);
  let resultObj: Record<string, singleIdentifiersMeta[]> = {};
  for (const key in originalIdentifierMap) {
    if (!Object.hasOwn(originalMeta, key)) {
      resultObj[`${key}::`] = [];
      continue;
    };
    const element = originalMeta[key];
    const field = element?.field ?? "";
    if (field && element.module && element.group && element.menu) {
      resultObj[`${key}::${field}`] = [
        {
          module: transElementToStr(element.module),
          section: transElementToStr(element.group),
          menu: transElementToStr(element.menu),
        },
      ];
    } else {
      resultObj[`${key}::${field}`] = [];
    }
  }
  return resultObj;
};

export const replaceParams = (url: string, context: Record<string, any>, formatValue?: (key: string, val: unknown) => unknown) => {
  if (!url) return "";
  for (const key in context) {
    if (context.hasOwnProperty(key)) {
      const value = context[key];
      const pattern = "${" + key + "}";
      url = url.replace(pattern, formatValue ? formatValue(key, value) : value);
    }
  }
  return url;
};

export const actionAlwaysPinnedRight = (originArr?: string[]) => {
  if (Array.isArray(originArr)) {
    const pinnedRightLen = originArr.length;
    if (originArr[pinnedRightLen - 1] !== "action") {
      const tempPinnedRight = originArr.filter((i) => i !== "action");
      tempPinnedRight.push("action");
      return tempPinnedRight;
    }
  }
  return originArr;
};

export const handleIdentifierMapOrder = (disableIdentifierList: string[], initFilterList: Record<string, any>) => {
  const tempJson: any = {};
  if (disableIdentifierList && disableIdentifierList.length > 0) {
    disableIdentifierList.forEach((item) => {
      if (initFilterList && initFilterList[item] !== undefined) {
        tempJson[item] = initFilterList[item];
      }
    })
  }
  if (initFilterList) {
    Object.keys(initFilterList).forEach((key) => {
      if (!disableIdentifierList?.includes(key)) {
        tempJson[key] = initFilterList[key];
      }
    })
  }
  return tempJson;
};

export const handleSelectedIdentifiers = (
  filterList: any,
  identifierList = {} as any,
  currentIdentifiers = {} as any,
  allSelected?: Record<string, boolean>
) => {
  let afterFilterList = {} as any;

  const removeItemsFromArray = (sourceArray: any[], itemsToRemove: any[]) => {
    return sourceArray.filter(item => !itemsToRemove.includes(item));
  };

  for (let key in filterList) {
    let filteredValue;

    if (Array.isArray(filterList[key])) {
      filteredValue = [...filterList[key]];
    } else {
      filteredValue = [filterList[key]];
    }

    if (identifierList[key]) {
      const itemsToRemove = Array.isArray(identifierList[key])
        ? identifierList[key]
        : [identifierList[key]];
      filteredValue = removeItemsFromArray(filteredValue, itemsToRemove);
    }

    if (filteredValue.length > 0 && currentIdentifiers[key]) {
      const itemsToAdd = Array.isArray(currentIdentifiers[key])
        ? currentIdentifiers[key]
        : [currentIdentifiers[key]];


      const combinedSet = new Set([...filteredValue, ...itemsToAdd]);
      filteredValue = Array.from(combinedSet);
    }

    if (filteredValue.length > 0) {
      afterFilterList[key] = allSelected?.[key] ? ['all' ] : filteredValue;
    }
  }
  return afterFilterList;
};

export const isLinkField = (
  sinlgeChangeField: Record<string, any>,
  settingsJson: Record<string, any>[]
) => {
  const curChangeTarget = sinlgeChangeField;
  const changeFieldSetting = settingsJson?.find(
    (i) => i.field === curChangeTarget.field
  );
  const curLinkFieldSetting = changeFieldSetting?.formRules?.linkField;

  return (
    Array.isArray(curLinkFieldSetting) &&
    curLinkFieldSetting?.length > 0 &&
    isEqual(changeFieldSetting?.linkFieldValue, curChangeTarget.value)
  );
};

export const encodingAndRecoverBlank = (originStr?: string | null) => {
  if (!!originStr) {
    return originStr;
  }
  const tempStr = encodeURIComponent(originStr!);
  const revertBlank = tempStr.toString().replace(/%20/g, " ");
  return revertBlank;
};

export const filterFormData = (
  formData?: Record<string, any>,
  extraFields?: string[],
): Record<string, any> => {
  if (!formData) return {};

  const excludeFields = new Set(
    (extraFields || []).map((field) => field.toLowerCase()),
  );

  return Object.keys(formData).reduce((filteredData, key) => {
    if (!excludeFields.has(key.toLowerCase())) {
      filteredData[key] = formData[key];
    }
    if (includeFields.includes(key.toLowerCase())) {
      filteredData[key] = formData[key];
    }
    return filteredData;
  }, {} as Record<string, any>);
};

/** True when on add/edit/view (or metadata variants) under a side menu, not the first-level menu page. */
export function isMenuRecordSubPage(
  pathname: string,
  routeRecordId?: string | null,
): boolean {
  if (routeRecordId) {
    return true;
  }
  if (/\/add\/?$/.test(pathname)) {
    return true;
  }
  if (/\/addmetadata\//.test(pathname)) {
    return true;
  }
  if (/\/(edit|view)\/[^/]+/.test(pathname)) {
    return true;
  }
  if (/\/(edit|view)metadata\//.test(pathname)) {
    return true;
  }
  if (/\/(edit|view)-(question|response)\//.test(pathname)) {
    return true;
  }
  if (pathname.includes("add-question") || pathname.includes("add-response")) {
    return true;
  }
  return false;
}

export function shouldShowMenuTitleTags(
  pathname: string,
  routeRecordId?: string | null,
): boolean {
  return !isMenuRecordSubPage(pathname, routeRecordId);
}